<template>
  <div class="fit-day">
    <div class="head">
      <button class="back-button" @click="$emit('back')">
        <img :src="require('./icons/prev.svg')" :alt="$t('noahfit.day.back_alt')" style="width: 12px; height: 12px; margin-right: 4px;" />
        {{ $t('noahfit.day.back') }}
      </button>
      <p>{{ formattedDate }}</p>
    </div>

    <div class="inputcontainer">
      <h3>{{ $t('noahfit.day.today_calories') }}</h3>
      <p class="info">{{ $t('noahfit.day.info') }}</p>
      <textarea v-model="userEatenToday" rows="8" maxlength="1500" :placeholder="$t('noahfit.day.placeholder')"></textarea>

      <p style="color: #1CC655; padding-left: 6px;" v-if="message">{{ message }}</p>

      <button v-if="!loading && showSaveButton" class="guncellebutonu" @click="save">{{ $t('noahfit.day.update') }}</button>

      <p v-if="loading && showSaveButton" style="color: #FFD300; margin-top: 12px;">
        {{ $t('noahfit.day.loading') }}
      </p>
      

      <div v-if="eatenFromAi" class="ai-output">
        <h4>{{ $t('noahfit.day.ai_analysis') }}</h4>
        <pre>{{ eatenFromAi }}</pre>
      </div>

      <div style="margin: 1rem 0; font-size: 1rem;" v-if="totalCal">
        {{ $t('noahfit.day.total_today') }} <strong>{{ totalCal.toLocaleString() }}</strong> {{ $t('noahfit.day.kcal_suffix') }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: ['day', 'month', 'year'],
  data() {
    return {
      userEatenToday: '',
      originalUserEatenToday: '', 
      eatenFromAi: '',
      totalCal: null,
      recordId: null,
      loading: false,
      message: ''
    };
  },
  computed: {
    formattedDate() {
      const m = this.month + 1 < 10 ? '0' + (this.month + 1) : this.month + 1;
      const d = this.day < 10 ? '0' + this.day : this.day;
      return `${this.year}-${m}-${d}`;
    },
    showSaveButton() {
      return this.userEatenToday.trim() !== this.originalUserEatenToday.trim();
    }
  },
  async mounted() {
    try {
      const res = await axios.get('/promo/user/eaten', {
        params: { date: this.formattedDate }
      });

      if (res.data) {
        this.userEatenToday = res.data.user_eaten_today;
        this.originalUserEatenToday = res.data.user_eaten_today; 
        this.recordId = res.data.id;
        this.eatenFromAi = res.data.eaten_from_ai;
        this.totalCal = res.data.total_cal;
      }
    } catch (err) {
      console.error('Veri çekilemedi:', err);
    }
  },
  methods: {
    async save() {
      this.loading = true;
      this.message = '';
      try {
        const payload = {
          user_eaten_today: this.userEatenToday,
          eaten_from_ai: '',
          total_cal: 0,
          created_at: this.formattedDate
        };

        if (this.recordId) {
          await axios.put('/promo/user/eaten', {
            id: this.recordId,
            ...payload
          });
        } else {
          const res = await axios.post('/promo/user/eaten', payload);
          this.recordId = res.data.id;
        }

        const aiRes = await axios.post('/promo/user/eaten/analyze', {
          id: this.recordId,
          user_eaten_today: this.userEatenToday
        });

        this.eatenFromAi = aiRes.data.eaten_from_ai;
        this.totalCal = aiRes.data.total_cal;
        this.message = this.$t('noahfit.day.save_success');
        this.originalUserEatenToday = this.userEatenToday; 
      } catch (err) {
        console.error(err);
        this.message = this.$t('noahfit.day.save_error');
      } finally {
        this.loading = false;
      }
    }
  }
}; 
</script>

<style scoped>
.fit-day {
  max-width: 1080px;
  margin: auto;
}
.head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.inputcontainer {
  padding: 1em 2px;
}
textarea {
  width: 100%;
  margin: 12px 0;
  padding: 10px;
  font-size: 14px;
}
button {
  padding: 8px 16px;
  margin-top: 10px;
}
.guncellebutonu {
  margin-top: 12px;
  background-color: #1a310d;
  border: none;
  cursor: pointer;
}
.back-button {
  border: none;
  min-width: 10em;
  min-height: 3em;
  background: linear-gradient(45deg, #050505, #021f1f, #050505);
  transition: transform 0.2s ease, box-shadow 0.3s ease, color 0.2s ease;
  font-weight: 300;
}
.back-button:hover {
  transform: scale(1.05);
  color: white;
  box-shadow: 0 5px 12px rgba(0, 104, 42, 0.2);
}
.info {
  color: #FFD300;
  margin: 0;
  padding: 0;
}
.ai-output {
  margin-top: 20px;
  background: #050505;
  border: 1px solid #233627;
  padding: 10px;
  border-radius: 6px;
}
pre {
  white-space: pre-wrap;
  font-size: 13px;
  line-height: 1.4;
  color: #b4e0bc;
}
</style>
